export default "__VITE_ASSET__DzEg$d$Z__"